import { pageSelectorGenerator } from '@test/pageSelectors';

export const ExternalCheckoutConfirmAndNotifySelectors = pageSelectorGenerator('ExternalCheckoutConfirmAndNotify', ['ContainerElement', 'YesIDidButton', 'GetHelpButton']);
